
import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  components: {}
})
export default class HomeTitle extends Vue {
    @Prop() private title?: string
    @Prop() private color?: string
}
